import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex items-center justify-between px-3">
    <div className="w-6 h-3 bg-zinc-300 dark:bg-zinc-600 rounded" />
    <div className="flex gap-2">
      <div className="w-4 h-1.5 bg-zinc-200 dark:bg-zinc-700 rounded" />
      <div className="w-4 h-1.5 bg-zinc-200 dark:bg-zinc-700 rounded" />
      <div className="w-4 h-1.5 bg-zinc-200 dark:bg-zinc-700 rounded" />
    </div>
  </div>
);

export default Thumbnail;
